<template>
  <div>
    <Tool>
      <template v-slot:title>
        <a-avatar :size="40" style="backgroundColor:#87d068">{{ name }}</a-avatar>
        <div style="font-size: 15px; margin-left: 15px">
          {{ timeFix }}, {{ welcome }}
        </div>
      </template>
    </Tool>
    <div class="content">
      <div style="text-align: center;">
        <h2 style="font-size: 64px;font-weight: 600;letter-spacing: 2px; color: rgb(111 111 111)">啥都签</h2>
        <p style="font-size: 37px; color: rgb(111 111 111)">一站式智能签证服务平台</p>
      </div>
      <div class="vbox">
        <img src="../assets/global.png" style="width: 100%;opacity: 0.1;">
      </div>
    </div>
  </div>
</template>

<script>

import Tool from '@/components/Tool.vue'

export default {
  name: 'Home',
  components: {
    Tool
  },
  data() {
    return {
      name: localStorage.getItem('username'),
      avatarColor: ['#c56cf0', '#ffb8b8', '#ff3838', '#ff9f1a', '#3ae374', '#227093', '#17c0eb', '#7158e2', '#4a69bd', '#706fd3'],
      welcome: this.getHello(),
      timeFix: this.getHelloTime(),
      loading: true,
      logList: [],
      taskList: [],
      issueList: [],

      tabListNoTitle: [
        {
          key: 'taskList',
          tab: '待处理任务',
        },
        {
          key: 'issueList',
          tab: '待处理问题',
        },
      ],
      noTitleKey: 'taskList',
      toTab: 'taskList',
    }
  },

  methods: {
    getHello() {
      const arr = ['休息一会儿吧', '准备吃什么呢?', '今天也要元气满满', '我猜你可能累了', '要不要去划下水']
      let index = Math.floor((Math.random() * arr.length))
      return arr[index]
    },
    getHelloTime() {
      const time = new Date()
      const hour = time.getHours()
      return hour < 9 ? '早上好' : (hour <= 11 ? '上午好' : (hour <= 13 ? '中午好' : (hour < 20 ? '下午好' : '晚上好')))
    },
  },

  mounted() {

  }

}
</script>

<style lang="less" scoped>

.vbox {
  overflow: hidden;
  width: 100%;
}

.banner-title {
  position: absolute;
  top: 26.75%;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 1;
  text-align: center;
}

</style>
